import { SessionTimeoutMonitorProps } from "./SessionTimeoutMonitor.types";
import { useLogoutId } from "../../app/Providers/AppContext";
import styles from "./SessionTimeoutMonitor.module.scss";
import { SessionTimeoutWarning } from "../SessionTimeoutWarning";
import { routes } from "../../routing/routes";
/**
 * Monitors if the user is idle for a specified period of time and logs the user out if the timeout expires.
 * This is a wrapper for the SessionTimeoutWarning component.
 */
export const SessionTimeoutMonitor = ({
  idleTime,
  timeoutDuration,
}: SessionTimeoutMonitorProps) => {
  const logoutId = useLogoutId();

  return (
    <SessionTimeoutWarning
      idleTime={idleTime}
      timeoutDuration={timeoutDuration}
      onTimeoutExpired={logout}
      className={styles.content}
    />
  );

  function logout(): void {
    window.location.assign(routes.logout(logoutId));
  }
};
